import _styled from "@emotion/styled/base";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { LoadingAnimation } from '../../../primitives/Loading/components/LoadingAnimation.js';
import { LabelXLargeSemibold, ParagraphMedium } from '../../../primitives/Typography/index.js';
export const Base = /*#__PURE__*/_styled(({
  title,
  subtitle
}) => {
  return _jsxs(_Fragment, {
    children: [_jsx(LabelXLargeSemibold, {
      textAlign: "center",
      children: title
    }), _jsx(LoadingAnimation, {}), _jsx(ParagraphMedium, {
      color: "contentSecondary",
      textAlign: "center",
      children: subtitle
    })]
  });
}, process.env.NODE_ENV === "production" ? {
  target: "efvvtpy0"
} : {
  target: "efvvtpy0",
  label: "Base"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhc2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTUciLCJmaWxlIjoiQmFzZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4LCBGcmFnbWVudCBhcyBfRnJhZ21lbnQsIGpzeHMgYXMgX2pzeHMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IExvYWRpbmdBbmltYXRpb24gfSBmcm9tICcuLi8uLi8uLi9wcmltaXRpdmVzL0xvYWRpbmcvY29tcG9uZW50cy9Mb2FkaW5nQW5pbWF0aW9uLmpzJztcbmltcG9ydCB7IExhYmVsWExhcmdlU2VtaWJvbGQsIFBhcmFncmFwaE1lZGl1bSB9IGZyb20gJy4uLy4uLy4uL3ByaW1pdGl2ZXMvVHlwb2dyYXBoeS9pbmRleC5qcyc7XG5leHBvcnQgY29uc3QgQmFzZSA9IHN0eWxlZCgoeyB0aXRsZSwgc3VidGl0bGUgfSkgPT4ge1xuICAgIHJldHVybiAoX2pzeHMoX0ZyYWdtZW50LCB7IGNoaWxkcmVuOiBbX2pzeChMYWJlbFhMYXJnZVNlbWlib2xkLCB7IHRleHRBbGlnbjogXCJjZW50ZXJcIiwgY2hpbGRyZW46IHRpdGxlIH0pLCBfanN4KExvYWRpbmdBbmltYXRpb24sIHt9KSwgX2pzeChQYXJhZ3JhcGhNZWRpdW0sIHsgY29sb3I6IFwiY29udGVudFNlY29uZGFyeVwiLCB0ZXh0QWxpZ246IFwiY2VudGVyXCIsIGNoaWxkcmVuOiBzdWJ0aXRsZSB9KV0gfSkpO1xufSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1CYXNlLmpzLm1hcCJdfQ== */");